import { Typography, TypographyProps } from '@razz-team/ui-web';
import { ApiStandingOrder } from '../../../openapi';
import { useMemo } from 'react';
import { formatServerMoney } from '@razz-team/utils';
import { useTranslation } from 'react-i18next';

export interface StandingOrderAmountProps extends TypographyProps {
  amount: ApiStandingOrder['predicate']['amount'];
}

export function StandingOrderAmount({ amount, ...props }: StandingOrderAmountProps) {
  const { t } = useTranslation();
  const text = useMemo(() => {
    if (!amount || (amount.type === 'Min' && amount.amount.amount === 0)) {
      return t('Any amount');
    }
    switch (amount.type) {
      case 'Both':
        return t('From {{min}} to {{max}}', {
          min: formatServerMoney(amount.min),
          max: formatServerMoney(amount.max),
        });
      case 'Min':
        return t('From {{min}}', {
          min: formatServerMoney(amount.amount),
        });
      case 'Max':
        return t('Up to {{max}}', {
          max: formatServerMoney(amount.amount),
        });
      default:
        return t('Unknown');
    }
  }, [amount, t]);

  return <Typography {...props}>{text}</Typography>;
}
